import React from 'react';
import ReactDOM from 'react-dom';


var firebase = require('firebase/app');
require("firebase/database");

var _ = require('lodash');
var moment = require("moment-timezone");
var createReactClass = require('create-react-class');
var PropTypes = require('prop-types');

firebase.initializeApp(config);

function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] === variable) {return pair[1];}
   }
    return false;
}

function changeText(e) {
    e.css('visibility', 'hidden');
    e.parent().css('transform', 'scaleX(1)');

    var scalex = (e.parent().parent().width()) / e.width() > 1 ? 1 : (e.parent().parent().width()) / e.width();
    e.parent().css('transform', 'scaleX(' + scalex + ')');
    e.css('visibility', 'visible');
}

// Menu Icon
function IconMenu() {
    return (
      <svg className="icon-menu" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <title>menu</title>
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
      </svg>
  );
}

// Arrow Icon
function IconArrowBack() {
    return (
      <svg className="icon-menu" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <title>arrow-back</title>
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
      </svg>
  );
}

// Arrow Done
function IconDone() {
    return (
      <svg className="icon-menu" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <title>done</title>
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
      </svg>
  );
}

window.showAthlete = function (eid, result, lanepos) {
    var data = "";

    //if ($("#addNote").val() !== "") {
    //    data = '{"gu":' + window.globalGU + ',"eid":' + eid + ',"result": ' + result + ', "lanepos":' + lanepos + ', "addNote":"' + $("#addNote").val() + '" }';
    //} else {
        data = '{"gu":' + window.globalGU + ',"eid":' + eid + ',"result": ' + result + ', "lanepos":' + lanepos + ' }';
    //}

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/SyncVideoboard/ShowAthleteLowerThird/' + eid, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.send(data);
};

window.showVAttempt = function (eid, an, height, attempt) {

    var data = '{"gu":' + window.globalGU + ',"eid":' + eid + ',"an":' + an + ',"attempt":' + attempt + ',"height":' + height + '}';

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/SyncVideoboard/ShowVAttempt/' + eid, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.send(data);
};
window.showHAttempt = function (eid, an, attempt) {
    var data = '{"gu":' + window.globalGU + ',"eid":' + eid + ',"an":' + an + ',"attempt":' + attempt + '}';

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/SyncVideoboard/ShowHAttempt/' + eid, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.send(data);
};

window.deleteEntry = function (eid) {
    //document.getElementById("deleteModal").modal('show');
    $('#deleteModal').off();
    $('#deleteModal').modal('show').one('click', '#confirmDelete', function (e) {
        $('#deleteModal').modal('hide');
        var xhr = new XMLHttpRequest();
        xhr.open('GET', '/api/Sync/DeleteEntry/' + eid, true);
        xhr.send(null);
    });
};

window.deleteEntryMark = function (eid, clear) {
    //document.getElementById("deleteModal").modal('show');
    $('#deleteModal').off();
    $('#deleteModal').modal('show').one('click', '#confirmDelete', function (e) {
        $('#deleteModal').modal('hide');
        var xhr = new XMLHttpRequest();
        xhr.open('GET', '/api/Sync/DeleteEntryMark/' + eid + "/" + clear, true);
        xhr.send(null);
    });
};

window.changeEntry = function (eid, action) {
    //document.getElementById("deleteModal").modal('show');
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/api/Sync/ChangeEntry/' + eid + "/" + action, true);
    xhr.send(null);
};


window.deleteSplit = function (eid, lap) {
    //document.getElementById("deleteModal").modal('show');
    $('#deleteModal').off();
    $('#deleteModal').modal('show').one('click', '#confirmDelete', function (e) {
        $('#deleteModal').modal('hide');
        var xhr = new XMLHttpRequest();
        xhr.open('GET', '/api/Sync/DeleteSplit/' + eid + "/" + lap, true);
        xhr.send(null);
    });
};

window.deleteSplitPoint = function (meid, lap) {
    //document.getElementById("deleteModal").modal('show');
    $('#deleteModal').off();
    $('#deleteModal').modal('show').one('click', '#confirmDelete', function (e) {
        $('#deleteModal').modal('hide');
        var xhr = new XMLHttpRequest();
        xhr.open('GET', '/api/Sync/DeleteSplitPoint/' + meid + "/" + lap, true);
        xhr.send(null);
    });
};

window.setCurrentSplit = function (meid, lap) {
            var xhr = new XMLHttpRequest();
        xhr.open('GET', '/api/Sync/SetCurrentSplit/' + meid + "/" + lap, true);
        xhr.send(null);
};

window.setCurrentHeat = function (meid, heat) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/api/Sync/SetCurrentHeat/' + meid + "/" + heat, true);
    xhr.send(null);
};

var FranklinApp = createReactClass({
    displayName: 'AppRoot',
    getDefaultProps: function() {
        return {
            meetID:1152
        };
    },
    getInitialState: function () {
        return {
            liveEvents: [],
            schedule: [],
            scores: [],
            currentEvent:null,
            meta: {},
            leftNav:false,
            selectedAthlete: null,
            hRight: null,
            vRight: null,
            selectedDay: moment().format("ddd, MMMM Do"),
            enr: null,
            activeTab: "results",
            localTZ: true,
            showFlag: false,
            showLogo: false,
            isScored: false,
            showFullScore: false,
            eid: null,
            records: null,
            baseRef: firebase.database().ref(this.props.meetID)
        };
    },
    componentWillMount: function () {
        var meetID = this.props.meetID;
        var metaRef = this.state.baseRef.child('Meta');
        var t = this;
        metaRef.once('value')
          .then(function (dataSnapshot) {
              var meta = dataSnapshot.val();
              meta.showLogo = meta.showLogo == undefined ? false : meta.showLogo;
              meta.showFlag = meta.showFlag == undefined ? false : meta.showFlag;
              meta.img = meta.img == undefined ? "" : meta.img;
              meta.LS = meta.LS == undefined ? false : meta.LS;

              t.setState({ meta: meta, showFlag: meta.showFlag, showLogo: meta.showLogo, isScored: meta.LS });
              if (meta.LS) {
                  var scoresRef = t.state.baseRef.child('Scores').orderByChild('L');
                  t.firebaseCallback = scoresRef.on('value', function (snap) {
                      var scoreItems = [];
                      snap.forEach(function (itemSnap) {
                          scoreItems.push(itemSnap.val());
                      });
                      t.setState({ scores: scoreItems });
                  });
              }
          });
        var scheduleRef = this.state.baseRef.child('Schedule').orderByChild('T');
        this.firebaseCallback = scheduleRef.on('value', function (snap) {
            var scheduleItems = [];
            snap.forEach(function (itemSnap) {
                scheduleItems.push(itemSnap.val());
            });
            t.setState({ schedule: scheduleItems });
        });        
    },
    componentWillUnmount: function() {
        this.state.baseRef.off();
        this.state.baseRef.child('/MeetEvents/' + this.state.enr).off();
    },
    handleDayClick: function (day) {
        if (day === this.state.selectedDay) {
            this.setState({selectedDay: null });
        } else {
            this.setState({ selectedDay: day });
        }
    },
    handleEventClick: function (enr) {
        var prevENR = this.state.enr;
        var t = this;
        if (enr !== prevENR) {
            this.setState({hRight:null,vRight:null});
            var eventRef = this.state.baseRef.child('/MeetEvents/' + enr);
            this.state.baseRef.child('/MeetEvents/' + prevENR).off();
            eventRef.on('value', function (snapshot) {
                t.setState({ currentEvent: snapshot.val(), enr: enr, leftNav: false, selectedAthlete: null, activeTab: "results", showFullScore: false });
            });
            var recordsRef = this.state.baseRef.child('Records/'+enr);
            recordsRef.once('value').then(function (dataSnapshot) {
                var records = dataSnapshot.val();
                t.setState({ records: records });
            });
        }
    },
    handleTabClick: function (tab) {
        this.setState({ activeTab: tab });
    },
    handleAthleteClick: function (aid,category,attempts,eid) {
        var athleteInfo;
        if (category == "h") {
            this.setState({ hRight: attempts, vRight: null, eid: eid });
        }

        if (category == "v") {
            this.setState({ vRight: attempts, hRight:null, eid:eid });
        }
        //var t = this;
        //var firebaseAthleteRef = this.state.baseRef.child('/Athletes/' + aid);
        //firebaseAthleteRef.once('value')
        //  .then(function (dataSnapshot) {
        //      athleteInfo = dataSnapshot.val();
        //      t.setState({selectedAthlete: athleteInfo});
        //  });  
    },
    handleTZChange: function (onoff,e) {
        if (onoff) {
            this.setState({ localTZ: onoff });
        } else {
            this.setState({ localTZ: onoff });
        }
        e.stopPropagation();
        
    },
    showLeftMenu: function () {
        this.setState({leftNav: true});
    },
    hideMenus: function () {
        this.setState({leftNav: false, selectedAthlete: null, hRight:null,vRight:null});
    },
    handleFullScoreClick: function () {
        if (this.state.enr !== null) {
            this.state.baseRef.child('/MeetEvents/' + this.state.enr).off();
        }
        this.setState({ showFullScore: true, selectedAthlete: null, currentEvent: null, leftNav: false, hRight:null,vRight:null });
    },
    setGU: function(event) {
        var now = new Date();
        //5 days * 24 hours/day * 3600 seconds/hour
        now.setTime(now.getTime() + 5 * 24 * 3600 * 1000);

        document.cookie = "VBU=" + event.target.value + "; expires=" + now.toUTCString() + "; path=/";
        window.globalGU = event.target.value;
        graphicsUnit = event.target.value;
    },
    showTeamScores(lid) {
        var data = "";
        data = '{"gu":' + window.globalGU + ',"mid":' + mid + ',"level":"' + lid + '"}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncVideoboard/ShowTeamScores/' + mid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    },
    showTeamScoresFull (lid) {
        var data = "";
        data = '{"gu":' + window.globalGU + ',"mid":' + mid + ',"level":"' + lid + '"}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncVideoboard/ShowTeamScoresFull/' + mid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    },
    clearFullPage() {
        var data = '{"gu":' + window.globalGU + ',"mid":' + mid + '}';
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncVideoboard/ClearFullPageGraphics/' + mid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    },
    clearLowerThird() {
        var data = '{"gu":' + window.globalGU + ',"mid":' + mid + '}';
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncVideoboard/ClearLowerThird/' + mid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    },
    clearTeamScoreSidebar() {
        var data = '{"gu":' + window.globalGU + ',"mid":' + mid + '}';
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncVideoboard/clearTeamScoreSidebar/' + mid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    },
    clearTeamScoreFull() {
        var data = '{"gu":' + window.globalGU + ',"mid":' + mid + '}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncVideoboard/clearTeamScoreFull/' + mid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    },
    changePage(change) {
        var data = "";
        pageCount = pageCount + change;
        data = '{"Page":' + pageCount + '}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncVideoboard/ChangePage/' + mid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    },
    showEventGraphics: function () {
        this.setState({ currentEvent: null });
    },
    render: function () {
        var showFullScore = this.state.showFullScore;
        var currentEvent = this.state.currentEvent;
        var ce = null, back = null, title = null;
        var topnavClass = "topNav";
        var secnavClass = "secNav tabstrip";
        var osl = this.state.showLogo;
        var osf = this.state.showFlag;
        var contentClass = "content";
        var leftNavClass = "leftNav", overlayClass = "", rightNavClass = "rightBar", overlayRightClass = "";
        var resultTabClass = this.state.activeTab=="results" ? "tab active": "tab";
        var recordsTabClass = this.state.activeTab == "records" ? "tab active" : "tab";;
        var rb;
        var roundName = null;
        var evtStatus = "";
        var scoreBar = null;
        var scoreStyle = "";
        var scoreLink = null;
        var eventNav = null;
        if (this.state.leftNav) {
            leftNavClass += " open";
            overlayClass += "navOpen";
        }
        var secNavTab = "Results";

        if (this.state.hRight || this.state.vRight) {
            rightNavClass += " open";
            overlayRightClass += "navOpen";
            if (this.state.hRight) {
                rb = <RightBar ce={this.state.currentEvent} meta={this.state.meta} category="h" attempts={this.state.hRight} eid={this.state.eid} />;
            } else {
                rb = <RightBar ce={this.state.currentEvent} meta={this.state.meta} category="v" attempts={this.state.vRight} eid={this.state.eid} />;
            }
            
        }
        var meetHome = [];
        
        //if (this.state.isScored) {
        //    scoreBar = <ScoreBar scores={this.state.scores } fullScoreClick={this.handleFullScoreClick}></ScoreBar>;
        //    scoreStyle = " withScores";
        //    scoreLink = <div><hr /><div className="eventLink day" onClick={() => this.handleFullScoreClick()} ><b>Team Scores</b></div><hr/></div>
        //}

        //topnavClass += scoreStyle;
        //secnavClass += scoreStyle;
        //contentClass += scoreStyle;
        //leftNavClass += scoreStyle;
        //rightNavClass += scoreStyle;

        //if (showFullScore) {
        //    title = <div id="appBarTitle">{this.state.meta.name}</div>;
        //    ce = <ScoresFull scores={this.state.scores } fullScoreClick={this.handleFullScoreClick}></ScoresFull>
        //    eventNav =<div id="eventNav" className="stripNav">
        //            <div className={resultTabClass}>Team Scores</div>

        //    </div>
        //} else 
        if (currentEvent) {
            if (this.state.activeTab == "results") {
                ce = <SelectedEvent currentEvent={currentEvent} meta={this.state.meta} osl={osl} osf={osf} athleteClick={this.handleAthleteClick} records={this.state.records} />;
            } else if (this.state.activeTab=="records") {
                ce = <Records records={this.state.records} />
            }
            back = <button id="eventArrowBack" className="icon"><IconArrowBack /></button>;
            if (currentEvent.RN) {

                roundName=currentEvent.RN=="Final"?<span> | <b>{currentEvent.RN}</b></span> : <span> | {currentEvent.RN}</span>
            }
            var mTime = this.state.localTZ ? moment(currentEvent.T).format("dddd h:mm A") : moment.parseZone(currentEvent.T).format("dddd h:mm A")
            title = <div id="appBarTitle"><div><span className='eventDateTime'>{mTime} {roundName}</span></div>{currentEvent.N}</div>;
            topnavClass += " eventTitle";
            evtStatus = currentEvent.S.replace(" ", "").toLowerCase()
            secnavClass += " event " + evtStatus;
            contentClass += " event noScorll";

            eventNav =<div id="eventNav" className="stripNav">
                    <div data-tab="result" className={resultTabClass} onClick={() => this.handleTabClick("results") }>
                        {secNavTab}
                    </div>
                    <div id="recordsTab" data-tab="records" className={recordsTabClass} onClick={() => this.handleTabClick("records") }>
                        Records
                    </div>
                </div>;

        }
        else {
            title = <div id="appBarTitle">{this.state.meta.name}</div>;
            ce = <EventGraphics mid={this.props.meetID} />;
            eventNav =<div id="eventNav" className="stripNav">
                    <div className={resultTabClass}>Select an event from the&nbsp;<span className="mobile">top</span><span className="notmobile">side</span>&nbsp;menu
                    </div>
            </div>
        }

        if (evtStatus === "notstarted" || evtStatus === "upnext") {
            secNavTab = "Start List";
        }

        if (this.state.meta.css && this.state.schedule.length > 0)
            return (
              <div>
              {scoreBar}
              <div id="overlay" className={overlayClass} onClick={this.hideMenus }></div>
              <div id="overlayRight" className={overlayRightClass} onClick={this.hideMenus }></div>
              <nav className={topnavClass}>
                <button id="leftNavOpen" className="icon" onClick={this.showLeftMenu }><IconMenu/></button>
                  {title}
              </nav>

              <nav className={leftNavClass} id="leftNav">
                <div className="header">
                    <img src={"/img/" + this.state.meta.logo } />
                    {this.state.meta.name}
                </div>
                <hr />
                <ScheduleDay schedule={this.state.schedule} meta={this.state.meta} selectedDay={this.state.selectedDay} localTZ={this.state.localTZ} tzClick={this.handleTZChange} dayClick={this.handleDayClick} eventClick={this.handleEventClick} />
                 
              </nav>

              <nav className={secnavClass }>
                <div id="liveNav" className="hide">
                    <div data-tab="result" className="tab active">
                        Event Graphics
                    </div>
                </div>
                {eventNav}
              </nav>

              <div id="rightBar" className={rightNavClass }>
                {rb}
              </div>
              
              <div className={contentClass} id="content">
                <div id="liveContent" className="hide">

                </div>

                <div id="eventContent">
                    {ce}
                </div>
            </div>  
          </div>
            );
        else
            return (<div className="loading">
                       <div className="spinner">
                      <div className="double-bounce1"></div>
                      <div className="double-bounce2"></div>
                    </div>Loading Data</div>);
   }
});

class RightBar extends React.Component {
    constructor(props) {
        super(props);
    }
    loadAAPage(AA) {
        window.open('http://www.all-athletics.com/node/' + AA, 'Athlete Detail');
    }
    loadTFRRSPage(TF) {
        window.open('https://www.tfrrs.org/athletes/'+TF, 'TFRRS Profile');
    }
    
    render() {
        var meta = this.props.meta;
        var athleteInfo = this.props.athleteInfo;
        var category = this.props.category;
        var attempts = this.props.attempts;
        var eid = this.props.eid;
        var t= this;

        var attemptArray = [];
        if (category == "h") {
            if (attempts == undefined) {
                attempts = [{ AN: 1 }];
            }

            if (attempts[0] == undefined) {
                attempts.splice(0, 1);
            }
            
            _.sortBy(attempts, 'AN').forEach(function (ele) {
                attemptArray.push(<tr key={"ha-" + ele.AN}><td>{ele.AN}</td><td>{ele.M}</td><td><button onClick={() => window.showHAttempt(eid, ele.AN, true)}>A</button></td><td><button onClick={() => window.showHAttempt(eid, ele.AN, false)}>R</button></td></tr>);
            });

            if (attempts.length < 6) {
                attemptArray.push(<tr key={"ha-" + (attempts.length + 1)}><td>{(attempts.length + 1)}</td><td>_</td><td><button onClick={() => window.showHAttempt(eid, ele.AN, true)}>A</button></td><td></td></tr>);
            }
        }

        if (category == "v") {
            var heights = this.props.ce.H.split(",");
            var va = [];
            _.each(heights, function (ele) {
                var height = _.findWhere(attempts, { H: parseFloat(ele) });
                va = [];
                if (height) {
                    var vattempts = height.A;
                    var success = false;
                    var x;
                    
                    for (x = 0; x < vattempts.length; x++) {
                        var i = x+1;
                        va.push(<tr><td>{vattempts.charAt(x)}</td><td><button onClick={() => window.showVAttempt(eid, i, ele, true)}>A</button></td><td><button onClick={() => window.showVAttempt(eid, i, ele, false)}>R</button></td></tr>);
                        if (vattempts.charAt(x) == "O") {
                            success = true;
                            break;
                        }
                    }
                    if (vattempts.length < 3 && !success) {
                        va.push(<tr><td>_</td><td><button onClick={() => window.showVAttempt(eid, vattempts.length+1, ele, true)}>A</button></td><td></td></tr>);
                    }
                } else {
                    va.push(<tr><td>_</td><td><button onClick={() => window.showVAttempt(eid, 1, ele, true)} >A</button></td><td></td></tr>);
                }
                attemptArray.push(<tr><td>{ele}</td><td><table><tbody>{va}</tbody></table></td></tr>);
            });
        }

        return (
            <div className="teamEventBar">
                <div className="heading">
                    Attempts
                </div>
                <div className="rb-content">
                    <table>
                        <tbody>
                            {attemptArray}
                        </tbody>
                    </table>
                </div>
            </div>
        );
   }
}

class ScheduleDay extends React.Component {
    constructor(props) {
        super(props);
   }
    render() {

        var skedSort = this.props.meta.hasOwnProperty("skedSort") ? this.props.meta.skedSort : "Session";
        var levelNav = this.props.meta.hasOwnProperty("levelNav") ? this.props.meta.levelNav : false;
        //this.props.meetEvents.sort(function (a, b) {
        //    if (Date.parse(a.DayTime) > Date.parse(b.DayTime)) {
        //        return 1;
        //    }
        //    if (Date.parse(a.DayTime) < Date.parse(b.DayTime)) {
        //        return -1;
        //    }
        //    return 0;
        //});
        
        var sked = {};
        var localTZ = this.props.localTZ;
        var score;

        var schedule = this.props.schedule.reduce((sked, n) => {
            var d = localTZ ? moment(n.T).format("ddd, MMMM Do") : moment.parseZone(n.T).format("ddd, MMMM Do");
            (sked.levels[n.L] = sked.levels[n.L] || []).push(n);
            (sked.days[d] = sked.days[d] || []).push(n);
            return sked;
        }, { levels: {}, days: {}});

        var eventClick = this.props.eventClick;
        var dayClick = this.props.dayClick;
        var selectedDay = this.props.selectedDay;
        var localClass = localTZ ? "tzActive" : "tzInactive";
        var eventClass = localTZ ? "tzInactive" : "tzActive";
        var timezone;

        if (Object.keys(schedule.days).length == 1 && !levelNav) {
            var prop; for (prop in schedule.days) break;
            selectedDay = prop;
        }

        if (moment.parseZone(this.props.schedule[0].T).format("Z")==moment().format("Z")) {
            timezone = <div className="timezone"><span className={localClass}>Local ({moment().tz(moment.tz.guess()).format('z')})</span></div>;
        } else {
            timezone = <div className="timezone"><a className={localClass} onClick={(e) => this.props.tzClick(true, e) }>Local ({moment().tz(moment.tz.guess()).format('z')})</a> | <a className={eventClass} onClick={(e) => this.props.tzClick(false, e) }>Event</a></div>;
        }
        var tz = 0;
        var createDay = function (day) {
            tz++;
            //var tzDiv = tz === 1 ? timezone : null;
            var tzDiv = timezone;
            var showDay;
            if (selectedDay === day) {
                if (skedSort == "Time") {
                    schedule.days[day].sort(function (a, b) {
                        var aSO = a.T;
                        var bSO = b.T;
                        if (aSO > bSO) return 1;
                        if (aSO < bSO) return -1;
                        return 0;
                    });
                } else {
                    schedule.days[day].sort(function (a, b) {
                        var aSO = a.HSO ? a.HSO : a.T;
                        var bSO = b.HSO ? b.HSO : b.T;
                        return aSO - bSO;
                    });
                }

                showDay = "dayEvents";
                return <div key={day}><hr /><div className="day" onClick={() => dayClick(day) }><b>{day}</b>{tzDiv}</div><div id="sked" className={showDay}><ScheduleEvent meetEvents={schedule.days[day]} eventClick={eventClick} localTZ={localTZ} /></div></div>;
            } else {
                showDay = "dayEvents hide";
                return <div key={day}><hr /><div className="day" onClick={() => dayClick(day)}><b>{day}</b></div><div id="sked" className={showDay}></div></div>;
            }

            
        };
        var createLevel = function (level) {
            var showDay;
            if (selectedDay === level) {
                if (level == "Decathlon" || level == "Heptathlon" || level == "Indoor Heptathlon" || level.includes("Pentathlon"))
                    schedule.levels[level].sort(function (a, b) {
                        return a.R - b.R;
                    });
                else
                    schedule.levels[level].sort(function (a, b) {
                        return a.SO - b.SO;
                    });
                showDay = "dayEvents";
                var tzDiv = timezone;
                return <div key={"sked"+level}><hr /><div className="day" onClick={() => dayClick(level)}><b>{level}</b>{tzDiv}</div><div id="sked" className={showDay}><ScheduleLevelEvent level={level} levelEvent={schedule.levels[level]} eventClick={eventClick} localTZ={localTZ} /></div></div>;
            } else if (level == "Decathlon" || level == "Heptathlon" || level == "Indoor Heptathlon" || level.includes("Pentathlon") || levelNav) {
                showDay = "dayEvents hide";
                return <div key={"sked" + level}><hr /><div className="day" onClick={() => dayClick(level)}><b>{level}</b></div><div id="sked" className={showDay}></div></div>;
            }
            else {
                return null;
            }
            
        };
        var dailyKeys=[], levelKeys=[];
        dailyKeys = Object.keys(schedule.days);  //.reverse()
        levelKeys = Object.keys(schedule.levels);  //.reverse()

        var multiSort = ["Decathlon", "Heptathlon", "Indoor Heptathlon", "Indoor Pentathlon"];

        levelKeys.sort(function (a, b) {
            var ai = multiSort.indexOf(a);
            var bi = multiSort.indexOf(b);

            if (ai>-1 && b>-1) {
                return a - b;
            }
            if (ai>-1 && bi==-1) {
                return -1;
            }
            if (ai == -1 && bi > -1) {
                return 1;
            }
            return a.toUpperCase() > b.toUpperCase();

        });


        return <div key="dailySked">{dailyKeys.map(createDay)}<hr />{levelKeys.map(createLevel)}</div>;
        
   }
}

class ScheduleEvent extends React.Component {
    constructor(props) {
        super(props);
   }
    render() {
        var eventClick = this.props.eventClick;
        var currentDay = 0;
        var newDay = null;
        var localTZ = this.props.localTZ
        
        var createEvent = function (meetEvent, index) {
            var roundName = null;
            if (meetEvent.RN) {
                if (meetEvent.RN == "Final") {
                    roundName = <small><b>{meetEvent.RN}</b></small>;
                } else {
                    roundName = <small>{meetEvent.RN}</small>;
                }
               
            }
            var status = meetEvent.S.toLowerCase().replace(" ", "");
            var rowClass = "skedRow " + status;
            var mTime = localTZ ? moment(meetEvent.T).format("h:mm A") : moment.parseZone(meetEvent.T).format("h:mm A");
            var timeCol = status==="complete" ?<IconDone/>: <span>{mTime} </span>;
            return (
              <tr key={meetEvent.ENR} className={rowClass} onClick={() => eventClick(meetEvent.ENR)}>
                    <td className="eNumber">{meetEvent.ENR}</td>
                <td>{meetEvent.N} {roundName}</td>
                <td className="time">{timeCol}</td>
              </tr>
            );
        };
        return <table className="skedTable"><tbody>{this.props.meetEvents.map(createEvent)}</tbody></table>;
   }
}

class ScheduleLevelEvent extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        var eventClick = this.props.eventClick;
        var localTZ = this.props.localTZ
        var le = this.props.levelEvent
        var ths = null;
        if (this.props.level === "Decathlon" || this.props.level === "Heptathlon" || this.props.level == "Indoor Heptathlon" || this.props.level.includes("Pentathlon") || this.props.level === "Exhibition") {
            
        } else {
            ths = <thead><tr><th>Event</th><th>Final</th><th>Semi</th><th>1st Rnd</th></tr></thead>;
        }

        var levelEvents = le.reduce((l, n) => {
            var eid = n.EID;
            (l[eid] = l[eid] || []).push(n);
            return l;
        }, {});

        var leKeys = Object.keys(levelEvents);
        var createLE = function (le) {
            levelEvents[le].sort(function (a, b) {
                return b.R - a.R;
            });

            var tds = levelEvents[le].map(function (e) {
                var dt = localTZ ? moment(e.T) : moment.parseZone(e.T);
                var status = e.S.toLowerCase().replace(" ", "");
                var tdClass = "dayTime " + status;
                var time = status === "complete" ? <IconDone/> : dt.format("H:mm");
                return <td className={tdClass} onClick={() => eventClick(e.ENR)}>{dt.format("dd, M/D")}<br/>{time}</td>                   
            });
            return <tr><td className="leName">{le}</td>{tds}</tr>
        };
        return <table className="skedTable leTable">{ths}<tbody>{leKeys.map(createLE)}</tbody></table>;
    }
}

class SelectedEvent extends React.Component {
    constructor(props) {
        super(props);
        this.updateStatus = this.updateStatus.bind(this);
        this.showLocator = this.showLocator.bind(this);
        this.setClock = this.setClock.bind(this);
        this.showStartList = this.showStartList.bind(this);
        this.showResults = this.showResults.bind(this);
        this.showTopResults = this.showTopResults.bind(this);
        this.showL2G = this.showL2G.bind(this);
        this.state = { rtypes: [] };
    }
    updateStatus(meid,status) {
        var xhr = new XMLHttpRequest();
        xhr.open('PATCH', '/api/Sync/UpdateStatus/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send('{"status":"' + status + '"}');
    }
    syncHytek(meid) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', '/api/Sync/SyncHytek/' + meid, true);
        xhr.send(null);
    }
    postOnline(meid) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', '/api/Sync/PostOnline/' + meid, true);
        xhr.send(null);
    }
    readLynx(meid) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', '/api/Sync/ReadLynx/' + meid, true);
        xhr.send(null);
    }
    deleteMEEntries(meid) {
        //document.getElementById("deleteModal").modal('show');
        $('#deleteModal').off();
        $('#deleteModal').modal('show').one('click', '#confirmDelete', function (e) {
            $('#deleteModal').modal('hide');
            var xhr = new XMLHttpRequest();
            xhr.open('GET', '/api/Sync/DeleteMEEntries/' + meid, true);
            xhr.send(null);
        });
    }
    showLocator(meid) {
        var data = "";

        data = '{"gu":' + window.globalGU + ',"meid":' + meid + '}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncVideoboard/ShowLocator/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    setClock(meid,heat,action) {
        var data = "";

        if (heat == 0) {
            data = '{"gu":' + window.globalGU + ', "action":"' + action + '", "meid":' + meid + '}';
        } else {
            data = '{"gu":' + window.globalGU + ', "action":"' + action + '", "meid":' + meid + ',"heat":' + heat + '}';
        }

        var xhr = new XMLHttpRequest();
        xhr.open('PATCH', '/api/SyncVideoboard/SetClock/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showStartList(meid,heat,page) {
        var data = "";

        if (heat == 0) {
            data = '{"gu":' + window.globalGU + ',"meid":' + meid + ',"page":' + page + '}';
        } else {
            data = '{"gu":' + window.globalGU + ',"meid":' + meid + ',"heat":' + heat + ',"page":' + page + '}';
        }

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncVideoboard/ShowStartList/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showResults(meid,heat,page) {
        var data = "";

        if (heat == 0) {
            data = '{"gu":' + window.globalGU + ',"meid":' + meid + ',"page":' + page + '}';
        } else {
            data = '{"gu":' + window.globalGU + ',"meid":' + meid + ',"heat":' + heat + ',"page":' + page + '}';
        }

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncVideoboard/ShowResults/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showTopResults(meid,count) {
        var data = "";

        data = '{"gu":' + window.globalGU + ',"meid":' + meid + ',"count":' + count + '}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncVideoboard/ShowResults/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showL2G(meid,heat,action,l2g) {
        var data = "";

        if (heat == 0) {
            data = '{"gu":' + window.globalGU + ', "action":"' + action + '", "meid":' + meid + ', "l2g":' + l2g + '}';
        } else {
            data = '{"gu":' + window.globalGU + ', "action":"' + action + '", "meid":' + meid + ',"heat":' + heat + ', "l2g":' + l2g + '}';
        }

        var xhr = new XMLHttpRequest();
        xhr.open('PATCH', '/api/SyncVideoboard/SetClock/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    setRecord(meid, rType) {
        if (this.state.rtypes.length < 2 && !this.state.rtypes.includes(rType)) {
            this.setState({ rtypes: this.state.rtypes.concat(rType)});
        } else if (this.state.rtypes.includes(rType)) {
            var rarray = this.state.rtypes;
            rarray.splice(rarray.indexOf(rType), 1);
            this.setState({ rtypes: rarray});
        }
        //alert(meid + "-" + rType);
    }
    showRecords(meid) {
        if (this.state.rtypes.length>0) {
            var action = "RECORDS"
            var data = "";

            data = '{"gu":' + window.globalGU +', "action":"' + action + '", "rtypes":"' + this.state.rtypes.join(",") + '","meid":' + meid + '}';

            var xhr = new XMLHttpRequest();
            xhr.open('PATCH', '/api/SyncVideoboard/SetClock/' + meid, true);
            xhr.setRequestHeader("Content-type", "application/json");
            xhr.send(data);
        }
    }
    clearRecords(meid) {
        var action = "CLEARRECORDS"
        var data = "";

        data = '{"gu":' + window.globalGU +', "action":"' + action + '", "meid":' + meid + '}';

        var xhr = new XMLHttpRequest();
        xhr.open('PATCH', '/api/SyncVideoboard/SetClock/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    resetRecords() {
        this.setState({ rtypes: [] });
    }
    showSplit(meid, heat,action,split) {
        var data = "";

        if (heat == 0) {
            data = '{"gu":' + window.globalGU +', "action":"' + action + '", "meid":' + meid + ', "splitnumber":' + split + '}';
        } else {
            data = '{"gu":' + window.globalGU +', "action":"' + action + '", "meid":' + meid + ',"heat":' + heat + ', "splitnumber":' + split + '}';
        }

        var xhr = new XMLHttpRequest();
        xhr.open('PATCH', '/api/SyncVideoboard/SetClock/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
     showManySplits(meid, heat,action,count) {
        var data = "";

        (function loopSplits(i) {
            setTimeout(function () {
                if (heat == 0) {
                    data = '{"gu":' + window.globalGU +', "action":"' + action + '", "meid":' + meid + ', "splitnumber":' + i + '}';
                } else {
                    data = '{"gu":' + window.globalGU +', "action":"' + action + '", "meid":' + meid + ',"heat":' + heat + ', "splitnumber":' + i + '}';
                }

                var xhr = new XMLHttpRequest();
                xhr.open('PATCH', '/api/SyncVideoboard/SetClock/' + meid, true);
                xhr.setRequestHeader("Content-type", "application/json");
                xhr.send(data);

                if (i++ < count) loopSplits(i);
            }, 250)
        })(1);
    }
     clearSplit(meid,heat,action) {
        var data = "";

        if (heat == 0) {
            data = '{"gu":' + window.globalGU +', "action":"' + action + '", "meid":' + meid + '}';
        } else {
            data = '{"gu":' + window.globalGU +', "action":"' + action + '", "meid":' + meid + ',"heat":' + heat + '}';
        }

        var xhr = new XMLHttpRequest();
        xhr.open('PATCH', '/api/SyncVideoboard/SetClock/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    
    render() {
        var currentEvent = this.props.currentEvent;
        var athleteClick = this.props.athleteClick;
        var meta = this.props.meta;
        var eventHeader = "";
        var entries = null;
        var wind = null;
        var qNote = currentEvent.QNote ? <div className="qNote">{currentEvent.QNote}</div> : null;
        var style;
        var ceRecords = this.props.records;

        currentEvent.OF = currentEvent.OF == undefined ? false : currentEvent.OF;
        currentEvent.OL = currentEvent.OL == undefined ? false : currentEvent.OL;

        if (this.props.osf && !currentEvent.OF || !this.props.osf && currentEvent.OF) {
            meta.showFlag = true;
        } else {
            meta.showFlag = false;
        }

        if (this.props.osl && !currentEvent.OL || !this.props.osl && currentEvent.OL) {
            meta.showLogo = true;
        } else {
            meta.showLogo = false;
        }
        
        if (currentEvent.S === "Not Started" || currentEvent.S === "Up Next") {
            eventHeader = "Start List";
            entries = currentEvent.ED ? <StartList entries={currentEvent.ED} athleteClick={athleteClick}></StartList> : <div>Entries not available</div>;
       } else if (currentEvent.S === "Complete") {
            eventHeader = "Results";
       } else if (currentEvent.S === "Reviewing") {
            eventHeader = "Standings - Finalizing";
        } else if (currentEvent.S === "Cancelled") {
            eventHeader = "Cancelled";
        } else {
            eventHeader = "In-Progress Standings";
       }

        if (currentEvent.S === "Not Started" || currentEvent.S === "Up Next" || currentEvent.S === "Cancelled") {
            entries = currentEvent.ED ? <StartList entries={currentEvent.ED} hasHeats={currentEvent.HH} athleteClick={athleteClick} meta={meta} eventType={currentEvent.E.C} meid={currentEvent.ID}></StartList> : <div>Entries not available</div>;
        } else if (currentEvent.E.C === "RUN" || currentEvent.E.C === "STRAIGHT" || currentEvent.E.C === "RELAY" || currentEvent.E.C === "XC" || currentEvent.E.C === "Road" || currentEvent.E.C === "STAGE" ) {
            if (!currentEvent.HR) {
                currentEvent.HR = false;
           }
            entries = currentEvent.ED ? <TrackResults currentEvent={currentEvent} athleteClick={athleteClick}  meta={meta}></TrackResults> : <div>Results currently not available</div>;
        } else if (currentEvent.E.C === "HJUMP" || currentEvent.E.C === "THROW") {
            entries = currentEvent.ED ? <HFieldResults currentEvent={currentEvent} athleteClick={athleteClick} meta={meta}></HFieldResults> : <div>Results currently not available</div>;
       }
        else if (currentEvent.E.C === "VJUMP") {
            entries = currentEvent.ED ? <VFieldResults currentEvent={currentEvent} athleteClick={athleteClick} meta={meta}></VFieldResults> : <div>Results currently not available</div>;
        } else if (currentEvent.E.C == "MULTI") {
            entries = currentEvent.ED ? <MultiResults entries={currentEvent.ED} athleteClick={athleteClick} meta={meta} eventType={currentEvent.L}></MultiResults> : <div>Results currently not available</div>;
        }
        
      
        
        return (
            <div id="result" className="tabContent">
                <div className="statusButtons btn-group" style={{marginTop:"15px"}} role="group">
                    <button className={"btn btn-status btn-outline-danger" + (currentEvent.S == "Not Started" ? " active" : "")} role='button' onClick={() => this.updateStatus(currentEvent.ID, "Not Started")}>Not Started</button>
                    <button className={"btn btn-status btn-outline-warning" + (currentEvent.S == "Up Next" ? " active" : "")} role='button' onClick={() => this.updateStatus(currentEvent.ID, "Up Next")}>Up Next</button>
                    <button className={"btn btn-status btn-outline-success" + (currentEvent.S == "Live" ? " active" : "")} role='button' onClick={() => this.updateStatus(currentEvent.ID, "Live")}>Live</button>
                    <button className={"btn btn-status btn-outline-info" + (currentEvent.S == "Reviewing" ? " active" : "")} role='button' onClick={() => this.updateStatus(currentEvent.ID, "Reviewing")}>Reviewing</button>
                    <button className={"btn btn-status btn-outline-primary" + (currentEvent.S == "Complete" ? " active" : "")} role='button' onClick={() => this.updateStatus(currentEvent.ID, "Complete")}>Complete</button>
                    <button className={"btn btn-status btn-outline-danger" + (currentEvent.S == "Cancelled" ? " active" : "")} role='button' onClick={() => this.updateStatus(currentEvent.ID, "Cancelled")}>Not Started</button>
                </div>
                <hr />
                <div className="btn-group" role="group">
                    <button onClick={() => this.syncHytek(currentEvent.ID)} className="btn btn-outline-secondary btn" role="button">Sync Hytek</button>
                    <button onClick={() => this.readLynx(currentEvent.ID)} className="btn btn-outline-secondary btn" role="button">Read Lynx</button>
                    <button onClick={() => this.postOnline(currentEvent.ID)} className="btn btn-outline-secondary btn" role="button">Post Online</button>
                    <button onClick={() => this.deleteMEEntries(currentEvent.ID)} className="btn btn-outline-danger btn" role="button">Delete All Entries</button>

                    <a href={"/MeetEvents/Edit/" + currentEvent.ID} className="btn btn-outline-info btn" role="button" target="_blank">Edit</a>
                </div>
                <hr />
                <h3><span id="eventResultHeader">{eventHeader}</span>
                </h3>
                   {qNote}
                   {wind}
                   {entries}
            </div>
        );
   }
}

class StartList extends React.Component {
    constructor(props) {
        super(props);
    }
    deleteEntry(eid) {
    }
    render() {
        var meta = this.props.meta;
        var entries = this.props.entries;
        var hasHeats = this.props.hasHeats;
        var eventType = this.props.eventType;
        var athleteClick = this.props.athleteClick;
        var meid = this.props.meid;

        var entryArray = [];
        var heatArray = [];

        for (var e in entries) {
            entryArray.push(entries[e]);
        }

        entryArray.sort(function (a, b) {
            var aInt = parseInt(a.LP);
            var bInt = parseInt(b.LP);
            if (aInt < bInt)
                return -1;
            if (aInt > bInt)
                return 1;
            return 0;
        });

        if (hasHeats) {
            heatArray = entryArray.reduce((heats, e) => {
                var heat = e.HSF || 0;
                (heats[heat] = heats[heat] || []).push(e);
                return heats;
            }, []);
            var heatStarts = heatArray.map(function (h, i) { return <StartListTable key={"sl" + meid + "-" + i} entryArray={h} meta={meta} hsf={i} hasHeats={hasHeats} eventType={eventType} athleteClick={athleteClick} meid={meid} /> });
            return <div>{heatStarts}</div>;
        }
            
        else {
            return <StartListTable key={"sl" + meid} entryArray={entryArray} meta={meta} hasHeats={hasHeats} athleteClick={athleteClick} meid={meid} />;   
        }
        
        
        
   }
}

class StartListTable extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        var meta = this.props.meta;
        var athleteClick = this.props.athleteClick;
        var entryArray = this.props.entryArray;
        var eventType = this.props.eventType;
        var heatWord = eventType === "RUN" || eventType === "STRAIGHT" || eventType === "RELAY" ? "Heat" : "Flight";
        var heatHead = null;
        if (this.props.hasHeats) {
            if (this.props.hsf === 0) {
                heatHead=<tr className="heatName"><th colSpan="4">Pending {heatWord} Assignment</th></tr>;
            } else {
                heatHead = <tr className="heatName"><th colSpan="4">{heatWord} {this.props.hsf} <button className="btn" onClick={() => window.setCurrentHeat(this.props.meid, this.props.hsf)}>Current</button></th></tr>;
            }
        }

        return <table className="raceResults">
                    <thead>
                        {heatHead}
                        <tr><th className="lnpos">Ln/Pos</th><th>&nbsp;</th><th>Athlete</th></tr>
                    </thead>
                    <tbody>{entryArray.map(function (e) { return <StartListRow key={"slr" + e.BIB} entry={e} showFlag={meta.showFlag} showLogo={meta.showLogo} showAff={meta.showAff} img={meta.img} athleteClick={athleteClick} />})}</tbody>
              </table>;
    }
}

class StartListRow extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        var entry = this.props.entry;
        var flag = null, aff = null;
        var athleteClick = this.props.athleteClick;
        
        if(this.props.showFlag) {
            flag = entry.A.CC ? <div className="aff"><img src={'/img/' + this.props.img + 'flags/' + entry.A.CC + '.png'} />{entry.A.CC}</div> : null;
        }
        if (this.props.showAff) {
            if (entry.TN) {
                if (this.props.showLogo) {
                    flag = entry.TC ? <div className="aff"><img src={'/img/' + this.props.img + 'logos/' + entry.TC + '.png'} /></div> : null;
                }
                var year = entry.Y ? "["+entry.Y+"]" : null;
                aff=entry.TN ? <div className="affiliation">{entry.TN} {year}</div>: null;
            } else {
                if (this.props.showLogo) {
                    flag = entry.A.TC ? <div className="aff"><img src={'/img/' + this.props.img + 'logos/' + entry.A.TC + '.png'} /></div> : null;
                }
                aff=entry.A.A ? <div className="affiliation">{entry.A.A}</div>: null;
            }
        }

        if (entry.RRD) {
            var year = entry.Y ? "[" + entry.Y + "]" : null;
            aff = <div className="affiliation">{year} {entry.RRD.filter(function(rr){return rr.L>0 && rr.L<=4}).map(function (rr) { return rr.A ? rr.A.N? rr.A.N: "" : ""}).join(", ")}</div>;
        }
        return (
            <tr>
                <td>{entry.LP}</td>
                <td style={{ width: '1px', whiteSpace: 'nowrap' }}>
                    <button className='btnAthleteID' onClick={() => window.changeEntry(entry.ID, "DNS")}>DNS<br />Toggle</button>&nbsp;&nbsp;
                    <button className='btnAthleteID' onClick={() => window.changeEntry(entry.ID, "DQ")}>DQ<br />Toggle</button>&nbsp;&nbsp;
                    <button className='btnAthleteID' onClick={() => window.deleteEntry(entry.ID)}>Delete<br />Entry</button>
                </td>
                
                <td className="athlete bold" onClick={() => athleteClick(entry.AID)}>{flag}<span>{entry.A.N}</span>{aff}</td>
            </tr>
        );

    }
}

class TrackResults extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        
        var meta = this.props.meta;
        var athleteClick = this.props.athleteClick;

        var meid = this.props.currentEvent.ID;
        var entries = this.props.currentEvent.ED;
        var hasHeats = this.props.currentEvent.HH;
        var hasSections = this.props.currentEvent.HSec;
        var eventType = this.props.currentEvent.E.C;
        var currentHeat = this.props.currentEvent.CH;
        var currentLap = this.props.currentEvent.CL;
        var splitList = this.props.currentEvent.SL;
        var bubble = this.props.currentEvent.BC;
        var hasReact = this.props.currentEvent.HR;
        var hasWind = this.props.currentEvent.HW;
        var status = this.props.currentEvent.S;

        var entryArray = [];
        var heatArray = [];
        var flip = false;
        
        for (var e in entries) {
            entryArray.push(entries[e]);
        }

        
        entryArray.sort(sortPlaces);

        var tableClass = "raceResults"; 
        var windRow=null;
        var reactTH = hasReact ? <th className="center">React</th> : null;
        var heatTH = hasHeats ? <th className="center">Heat</th> : null;
        var windTH = hasHeats && hasWind ? <th className="center">Wind</th> : null;
        var splits = [];
        var splitReverse = false;
        if (splitList) {
            splits = splitList.split(",");
            if (splits.length > 4) {
                tableClass += "";
           }
            var cl = currentHeat > 1 ? splits.length : currentLap;
                entryArray.sort(function (a, b) {

                    var aPlace; 
                    var bPlace;
                    if (a.P) 
                        aPlace = a.P;
                    else if (a.DNS)
                        aPlace = 999999;
                    else if (a.DQ)
                        aPlace = 999995;
                    else if (a.DNF)
                        aPlace = 999990;
                    else if (a.SPD)
                        aPlace = a.SPD[cl] ? a.SPD[cl].P : undefined;
                    else
                        if (a.sortPlace)
                            aPlace = a.sortPlace;
                            //aPlace = a.HSF * 1000 + a.LP;
                        else
                            aPlace = 999999;

                    if (b.P)
                        bPlace = b.P;
                    else if (b.DNS)
                        bPlace = 999999;
                    else if (b.DQ)
                        bPlace = 999995;
                    else if (b.DNF)
                        bPlace = 999990;
                    else if (b.SPD)
                        bPlace = b.SPD[cl] ? b.SPD[cl].P : undefined;
                    else
                        if (b.sortPlace)
                            bPlace = b.sortPlace;
                            //bPlace = b.HSF * 1000 + b.LP;
                        else
                            bPlace = 999999;

                    if (cl > 1) {
                        if ((!aPlace || aPlace === 9999) && a.SPD[cl - 1]) aPlace = 500 + a.SPD[cl - 1].P; else if ((!aPlace || aPlace === 9999) && a.sortPlace) aPlace = a.sortPlace;
                        if ((!bPlace || bPlace === 9999) && b.SPD[cl - 1]) bPlace = 500 + b.SPD[cl - 1].P; else if ((!bPlace || bPlace === 9999) && b.sortPlace) bPlace = b.sortPlace;
                    }

                    if (!aPlace)
                        return 1;
                    if (!bPlace)
                        return -1;
                    if (aPlace < bPlace)
                        return -1;
                    if (aPlace > bPlace)
                        return 1;
                    return 0;
               });

            //changing this.props.currentLap to cl to allow for all splits on compiled results when heats
                splits.splice(cl, splits.length - cl);
                if (status == "Live" || status == "Reviewing") {
                    splits.reverse();
                    splitReverse = true;
                }
       }

        if (entryArray[0].W !== undefined && entryArray[0].W !== "" && !hasHeats && hasWind) {
            var windRowClass = entryArray[0].W > 2 ? "resultWind aided" : "resultWind";
            windRow=<tr><th colSpan="4" className={windRowClass}>Wind: {entryArray[0].W.toFixed(1)} m/s</th></tr>;
        }
        
        var createEntry = function (entry, index) {
            var reactTD=null;
            var heatTD=null;
            var windTD = null;
            var tiebreak = null;
            var tsPoints = null;
            if (entry.hasOwnProperty("PT")) {
                tsPoints =  entry.PT == 1 ? <div className="small tsPoints">{entry.PT} Pt</div> : <div className="small tsPoints">{entry.PT} Pts</div>;
            }

            if (hasReact) {
                if (entry.RT)
                    reactTD = <td className="center">{entry.RT.toFixed(3)}</td>;
                else
                    reactTD = <td className="center"></td>;
           }

            if (hasHeats) {
                if (entry.HP) {
                    heatTD = <td className="center">{entry.HSF} ({entry.HP})</td>;
                } else {
                    heatTD = <td className="center">{entry.HSF}</td>;
                }
                
                if (hasWind) {
                    if (entry.W !== undefined && entry.W!=="") {
                        var windTDClass = entry.W > 2 ? "center aided" : "center";
                        windTD = <td className={windTDClass}>{entry.W.toFixed(1)} m/s</td>;
                   } else {
                        windTD = <td></td>;
                   }
               }
           }
            if (entry.MTB) {
                tiebreak=<div className="small">{entry.MTB}</div>;
            }

            var current = null;
            
            if (entry.ID === bubble) {
                current = "bubble";
            }
            
                 
            var place = null, flag = null, aff = null;
            if(meta.showFlag) {
                flag = entry.A.CC ? <div className="aff"><img src={'/img/' + meta.img + 'flags/' + entry.A.CC + '.png'} />{entry.A.CC}</div> : null;
            }
            if (meta.showAff) {
                if (entry.TN) {
                    if (meta.showLogo) {
                        flag = entry.TC ? <div className="aff"><img src={'/img/' + meta.img + 'logos/' + entry.TC + '.png'} /></div> : null;
                    }
                    var year = entry.Y ? "[" + entry.Y + "]" : null;
                    aff=entry.TN ? <div className="affiliation">{entry.TN} {year}</div>: null;
                } else {
                    if (meta.showLogo) {
                        flag = entry.A.TC ? <div className="aff"><img src={'/img/' + meta.img + 'logos/' + entry.A.TC + '.png'} /></div> : null;
                    }
                    aff=entry.A.A ? <div className="affiliation">{entry.A.A}</div>: null;
                }
            }

            if (entry.RRD) {
                var year = entry.Y ? "[" + entry.Y + "]" : null;
                aff = <div className="affiliation">{year} {entry.RRD.filter(function(rr){return rr.L>0 && rr.L<=4}).map(function (rr) { return rr.A ? rr.A.N? rr.A.N: "" : ""}).join(", ")}</div>;
            }

            if (entry.DNS || entry.P === 999) place = "DNS";
                else if (entry.DNF || entry.P === 997) place = "DNF";
                else if (entry.DQ || entry.P === 996) place = "DQ";
                else if (entry.P === 998) place = "FS";
                else if (entry.P) place = entry.P;

            var dqr=null;
            if (entry.hasOwnProperty("DQR")) {
                if (entry.DQR == "FS") place = "FS";
                else dqr=<small>[{entry.DQR}]</small>
            }

            var multiPoints = null;
            if (entry.hasOwnProperty('MP')) {
                multiPoints = <span className="multipoints">{entry.MP} <small>{entry.MPST} ({entry.MPSTP})</small></span>
            }

            

            if (!hasHeats || place !== null) 
                return (
                <tr key={entry.BIB} className={current }>
                <td className="bold">{place}</td>
                <td style={{ width: '1px', whiteSpace: 'nowrap' }}>
                            <button className='btnAthleteID' onClick={() => window.changeEntry(entry.ID, "DNS")}>DNS<br />Toggle</button>&nbsp;&nbsp;
                            <button className='btnAthleteID' onClick={() => window.changeEntry(entry.ID, "DNF")}>DNF<br />Toggle</button>&nbsp;&nbsp;
                            <button className='btnAthleteID' onClick={() => window.changeEntry(entry.ID, "DQ")}>DQ<br />Toggle</button>&nbsp;&nbsp;
                            {/* Short Track Speedskating
                            <button className='btnAthleteID' onClick={() => window.changeEntry(entry.ID, "YC")}>DQ<br />Yellow</button>
                            <button className='btnAthleteID' onClick={() => window.changeEntry(entry.ID, "RC")}>DQ<br />Red</button>
                            */}
                            <button className='btnAthleteID' onClick={() => window.deleteEntry(entry.ID)}>Delete<br />Entry</button>&nbsp;&nbsp;
                            <button className='btnAthleteID' onClick={() => window.deleteEntryMark(entry.ID, true)}>Clear<br />Mark & Splits</button></td>
                
                <td className="athlete bold">{flag}<span>{entry.A.N}</span>{aff}</td>
                <td className="mark right bold" onClick={() => window.deleteEntryMark(entry.ID, false)}>{entry.M} {multiPoints}{entry.Q} {tiebreak}{dqr} {tsPoints}</td>
                {reactTD}
                {splits.map(function (split, i) {
                    var ls = "-", mv = null;
                    var iPos = splitReverse ? splits.length - i : i + 1;
                    if (entry.SPD) {
                        if (entry.SPD[iPos]) {
                            if (entry.SPD[iPos].P !== 9999) {
                                if (iPos > 1) {
                                    ls = entry.SPD[iPos].LS;
                                    if (entry.SPD[iPos].M > 0)
                                        mv = <span className="up">{entry.SPD[iPos].M}</span>;
                                    else if (entry.SPD[iPos].M < 0)
                                        mv = <span className="down">{entry.SPD[iPos].M}</span>;
                                    else if (entry.SPD[iPos].M === 0)
                                        mv = <span className="same"></span>;
                                }
                                return <td key={entry.BIB + "-S" + (iPos)} className="center split" onClick={() => window.deleteSplit(entry.ID, iPos)}>
                              <div>{entry.SPD[iPos].CS}</div>
                              <div className="small">{ls}</div>
                              <div className="small">Pl: {entry.SPD[iPos].P} {mv}</div>
                          </td>;
                            } else {
                                return <td key={entry.BIB + "-S" + (iPos)} className="center split"></td>;
                            }
                        } else {
                            return <td key={entry.BIB + "-S" + (iPos)} className="center split"></td>;
                        }
                    } else {
                        return <td key={entry.BIB + "-S" + (iPos)} className="center split"></td>;
                    }
                })}
                {windTD}
                {heatTD}
                <td className="center">{entry.LP}</td>
            </tr>
            ); else
                return null;
        };

        var heatbyheatHeading = null;

        if (hasHeats) {
            heatArray = entryArray.reduce((heats, e) => {
                var heat = e.HSF || 0;
                (heats[heat] = heats[heat] || []).push(e);
                if ('P' in e) heats[heat].HasPlaces = true;
                return heats;
            }, []);

            var heatStarts = heatArray.map(function (h, i) {
                if (h["HasPlaces"])
                    return <div><HeatResultTable key={"hhrt-" + i} entryArray={h} meta={meta} hsf={i} hasHeats={hasHeats} hasWind={hasWind} eventType={eventType} meid={meid} /></div>
                else 
                    return <div><StartListTable key={"hsrt-" + i} entryArray={h} meta={meta} hsf={i} hasHeats={hasHeats} eventType={eventType} meid={meid} /></div>
            });
            
            heatbyheatHeading = hasSections ? <h3>Section-by-Section</h3> : <h3>Heat-by-Heat</h3>

        }

        var currentHeatTable = null;
        var compiledHead = null;
        if (hasHeats && currentHeat) {
            currentHeatTable = <HeatTrackResults currentEvent={this.props.currentEvent} athleteClick={athleteClick} meta={meta}/>;
            compiledHead=<h3>Compiled Results</h3>;
        }

        return <div className="resultsDiv">
                {currentHeatTable}
                {compiledHead}
                <table className={tableClass}>
                    <thead>
                       {windRow}
                    <tr><th>Place</th><th></th><th>Athlete</th><th className='right'>Result</th>{reactTH}{splits.map(function (split, i) { return <th key={split + "m"} className="center splitHeader"><div onClick={() => window.deleteSplitPoint(meid, i + 1)}>{split}</div><button className="btn" onClick={() => window.setCurrentSplit(meid, splitReverse ? splits.length - i : i + 1)}>Current</button></th>;})}{windTH}{heatTH}<th className="center">Ln/Pos</th></tr>
                    </thead>
                    <tbody>{entryArray.map(createEntry)}</tbody>
              </table>
                <div className="raceSmall heatbyheat">{heatbyheatHeading}{heatStarts}</div>
              </div>

   }
}

class HFieldResults extends React.Component {
    constructor(props) {
        super(props);
        this.state = { posSort: false };
        this.posSort = this.posSort.bind(this);
    }
    posSort() {
        this.setState({ posSort: !this.state.posSort });
    }
    render() {

        var meta = this.props.meta;
        var athleteClick = this.props.athleteClick;

        var hasHeats = this.props.currentEvent.HH;
        var entries = this.props.currentEvent.ED;
        var currentAthlete = this.props.currentEvent.CC;
        var currentAthlete2 = this.props.currentEvent.CC2;
        var bubble = this.props.currentEvent.BC;

        var entryArray = [];
        var attempts;
        for (var e in entries) {
            entryArray.push(entries[e]);
       }

        if (this.state.posSort) {
            entryArray.sort(sortPos);
        } else {
            entryArray.sort(sortPlaces);
        }

        var tableClass = "raceResults";

        var createEntry = function (entry, index) {
            var place=null, flag = null, aff = null;
            var tsPoints=null
            if (entry.hasOwnProperty("PT")) {
                tsPoints =  entry.PT == 1 ? <div className="small tsPoints">{entry.PT} Pt</div> : <div className="small tsPoints">{entry.PT} Pts</div>;
            }
            if(meta.showFlag) {
                flag = entry.A.CC ? <div className="aff"><img src={'/img/' + meta.img + 'flags/' + entry.A.CC + '.png'} />{entry.A.CC}</div> : null;
            }
            if (meta.showAff) {
                if (entry.TN) {
                    if (meta.showLogo) {
                        flag = entry.TC ? <div className="aff"><img src={'/img/' + meta.img + 'logos/' + entry.TC + '.png'} /></div> : null;
                    }
                    var year = entry.Y ? "[" + entry.Y + "]" : null;
                    aff=entry.TN ? <div className="affiliation">{entry.TN} {year}</div>: null;
                } else {
                    if (meta.showLogo) {
                        flag = entry.A.TC ? <div className="aff"><img src={'/img/' + meta.img + 'logos/' + entry.A.TC + '.png'} /></div> : null;
                    }
                    aff=entry.A.A ? <div className="affiliation">{entry.A.A}</div>: null;
                }
            }

            var windBest=null;
            var current="";
            if (entry.ID == currentAthlete || entry.ID == currentAthlete2) {
                current = "current";
            }

            if (entry.ID === bubble) {
                current += " bubble";
            }

            if (entry.DNS || entry.P === 999) place = "DNS";
            else if (entry.DNF || entry.P === 997) place = "DNF";
            else if (entry.DQ || entry.P === 996) place = "DQ";
            else if (entry.P === 998) place = null;
            else if (entry.P) place = entry.P;
            attempts = [];

            var fractions = function (m) {
                if (m)
                    return m.replace("&#188;", "\u00BC").replace("&#189;", "\u00BD").replace("&#190;", "\u00BE");
                else
                    return null;
            };

            var anStart = 1;
            var anEnd = 6;

            if (entry.HAD) {
                if (entry.HAD[0]) {
                    anStart = 0;
                    anEnd = 5;
                }
            }
            
            for ( var an = anStart; an <= anEnd; an++) {
                var wind = null;
                var anplace = null;
                var english=null;  
                if (entry.HAD) {
                    if (entry.HAD[an]) {
                        if (entry.HAD[an].M) {
                            var tdClass = entry.HAD[an].MM === entry.MM && entry.HAD[an].MM !== -1 ? "hAttempt best" : "hAttempt";

                            if (entry.HAD[an].W !== undefined && entry.HAD[an].W !== "" && entry.HAD[an].M !=="P") {
                                var attemptWindClass = entry.HAD[an].W > 2 ? "wind aided" : "wind";
                                wind = <div className={attemptWindClass }>{entry.HAD[an].W.toFixed(1)}</div>;
                            }
                            if (entry.HAD[an].P) {
                                if (entry.HAD[an].P !== 0 && entry.HAD[an].P !== 998)
                                    anplace = <div className='place'>{entry.HAD[an].P}</div>;
                            }
                            if (entry.HAD[an].ME && entry.MM !== -1) {
                                english = <div className="english">{fractions(entry.HAD[an].ME)}</div>;
                            }

                            attempts.push(<td key={entry.BIB + "-AN" + an} className={tdClass }>{entry.HAD[an].M}{english}{wind}{anplace}</td>);
                        } else {
                            attempts.push(<td key={entry.BIB + "-AN-" + an }></td>);
                        }
                    } else {
                        attempts.push(<td key={entry.BIB + "-AN-" + an }></td>);
                    }
                } else {
                    attempts.push(<td key={entry.BIB + "-AN-" + an }></td>);
                }
           }

            if (entry.W !== undefined && entry.W !== "") {
                var windClass= entry.W>2 ?"wind aided":"wind";
                windBest = <div className={windClass}>{entry.W.toFixed(1)}</div>;
            }

            
            var lphText = "";
            if (hasHeats) {
               lphText=entry.HSF+"-"+entry.LP;
            } else {
                lphText=entry.LP;
            }
            if (entry.PF) {
                lphText+="|"+entry.PF;
            }

            var lph = <td className="center">{lphText}</td>;
            

            var multiPoints = null;
            if (entry.hasOwnProperty('MP')) {
                multiPoints = <span className="multipoints">{entry.MP} <small>{entry.MPST} ({entry.MPSTP})</small></span>
            }
            return (
              <tr key={entry.BIB} className={current}>
                  <td className="bold">{place}</td>
                  <td style={{ width: '1px', whiteSpace: 'nowrap' }}>
                        <button className='btnAthleteID' onClick={() => window.changeEntry(entry.ID, "DNS")}>DNS<br />Toggle</button>&nbsp;&nbsp;
                        <button className='btnAthleteID' onClick={() => window.changeEntry(entry.ID, "DNF")}>DNF<br />Toggle</button>&nbsp;&nbsp;
                        <button className='btnAthleteID' onClick={() => window.changeEntry(entry.ID, "DQ")}>DQ<br />Toggle</button>&nbsp;&nbsp;
                        <button className='btnAthleteID' onClick={() => window.changeEntry(entry.ID, "Current")}>Current<br />Toggle</button>&nbsp;&nbsp;
                        <button className='btnAthleteID' onClick={() => window.deleteEntry(entry.ID)}>Delete<br />Entry</button>&nbsp;&nbsp;
                        <button className='btnAthleteID' onClick={() => window.deleteEntryMark(entry.ID, true)}>Clear<br />Series</button>
                    </td>
                  
                  <td className="athlete bold" onClick={() => athleteClick(entry.AID, "h", entry.HAD, entry.ID)}>{flag}<span>{entry.A.N}</span>{aff}</td>
                  <td className="mark center bold">{entry.M} {multiPoints}{entry.Q}{entry.DQR}<div className="english">{fractions(entry.ME)}{windBest}</div>{tsPoints}</td>
                  {attempts}
                  {lph}
              </tr>
            );
       };

        return <table className={tableClass}>
                    <thead>
                <tr><th>Place</th><th></th><th>Athlete</th><th className='center'>Result</th><th className='hAttempt'>1st</th><th className='hAttempt'>2nd</th><th className='hAttempt'>3rd</th><th className='hAttempt'>4th</th><th className='hAttempt'>5th</th><th className='hAttempt'>6th</th>
                        <th className="center hand" onClick={() => this.posSort()}>Pos</th></tr>
                    </thead>
                    <tbody>{entryArray.map(createEntry)}</tbody>
                </table>;
   }
}

class VFieldResults extends React.Component {
    constructor(props) {
        super(props); this.state = { posSort: false };
        this.state = { posSort: false };
        this.posSort = this.posSort.bind(this);
    }
    posSort() {
        this.setState({ posSort: !this.state.posSort });
    }
    render() {

        var meta = this.props.meta;
        var athleteClick = this.props.athleteClick;

        var entries = this.props.currentEvent.ED;
        var currentAthlete = this.props.currentEvent.CC;
        var currentAthlete2 = this.props.currentEvent.CC2;
        var bubble = this.props.currentEvent.BC;
        var hasHeats = this.props.currentEvent.HH;
        var heights = this.props.currentEvent.H.split(",");
        var heightsEng = this.props.currentEvent.HE.split(",");

        var fractions = function (m) {
            if (m)
                return m.replace("&#188;", "\u00BC").replace("&#189;", "\u00BD").replace("&#190;", "\u00BE");

            else
                return null;
        };
        var entryArray = [];
        for (var e in entries) {
            entryArray.push(entries[e]);
       }

        if (this.state.posSort) {
            entryArray.sort(sortPos);
        } else {
            entryArray.sort(sortPlaces);
        }

        for (var i = heights.length - 1; i--;) {
            if (heights[i] === "" || isNaN(heights[i])) heights.splice(i, 1);
            heightsEng[i] = fractions(heightsEng[i]);
       }
        var heightsTH = [];
        var useEnglish = this.props.currentEvent.hasOwnProperty("UE") ? this.props.currentEvent.UE : false;
        heights.map(function (height, i) {
            if (useEnglish) {
                heightsTH.push(<th key={"vrth"+i} className='vAttempt'>{heightsEng[i]}</th>);
            } else {
                heightsTH.push(<th key={"vrth" + i} className='vAttempt'>{height}<br />{heightsEng[i]}</th>);
            }
       });

        var tableClass = "raceResults";

        var createEntry = function (entry, index) {
            var place=null, flag = null, aff = null;
            var tsPoints=null
            if (entry.hasOwnProperty("PT")) {
                tsPoints =  entry.PT == 1 ? <div className="small tsPoints">{entry.PT} Pt</div> : <div className="small tsPoints">{entry.PT} Pts</div>;
            }
            if(meta.showFlag) {
                flag = entry.A.CC ? <div className="aff"><img src={'/img/' + meta.img + 'flags/' + entry.A.CC + '.png'} />{entry.A.CC}</div> : null;
            }
            if (meta.showAff) {
                if (entry.TN) {
                    if (meta.showLogo) {
                        flag = entry.TC ? <div className="aff"><img src={'/img/' + meta.img + 'logos/' + entry.TC + '.png'} /></div> : null;
                    }
                    var year = entry.Y ? "[" + entry.Y + "]" : null;
                    aff=entry.TN ? <div className="affiliation">{entry.TN} {year}</div>: null;
                } else {
                    if (meta.showLogo) {
                        flag = entry.A.TC ? <div className="aff"><img src={'/img/' + meta.img + 'logos/' + entry.A.TC + '.png'} /></div> : null;
                    }
                    aff=entry.A.A ? <div className="affiliation">{entry.A.A}</div>: null;
                }
            }
            var current = "";
            if (entry.ID === currentAthlete || entry.ID == currentAthlete2) {
                current = "current";
            }

            if (entry.ID === bubble) {
                current += " bubble";
            }

            if (entry.DNS || entry.P === 999) place = "DNS";
            else if (entry.DNF || entry.P === 997) place = "DNF";
            else if (entry.DQ || entry.P === 996) place = "DQ";
            else if (entry.P === 998) place = "NH";
            else if (entry.P) place = entry.P;

            

            var lphText = "";
            if (hasHeats) {
               lphText=entry.HSF+"-"+entry.LP;
            } else {
                lphText=entry.LP;
            }
            if (entry.PF) {
                lphText+="|"+entry.PF;
            }

            var lph = <td className="center">{lphText}</td>;


            var multiPoints = null;
            if (entry.hasOwnProperty('MP')) {
                multiPoints = <span className="multipoints">{entry.MP} <small>{entry.MPST} ({entry.MPSTP})</small></span>
            }

            return (
              <tr key={entry.BIB} className={current}>
                    <td className="bold">{place}</td>
                    <td style={{ width: '1px', whiteSpace: 'nowrap' }}>
                        <button className='btnAthleteID' onClick={() => window.changeEntry(entry.ID, "DNS")}>DNS<br />Toggle</button>&nbsp;&nbsp;
                        <button className='btnAthleteID' onClick={() => window.changeEntry(entry.ID, "DNF")}>DNF<br />Toggle</button>&nbsp;&nbsp;
                        <button className='btnAthleteID' onClick={() => window.changeEntry(entry.ID, "DQ")}>DQ<br />Toggle</button>&nbsp;&nbsp;
                        <button className='btnAthleteID' onClick={() => window.changeEntry(entry.ID, "Current")}>Current<br />Toggle</button>&nbsp;&nbsp;
                        <button className='btnAthleteID' onClick={() => window.deleteEntry(entry.ID)}>Delete<br />Entry</button>&nbsp;&nbsp;
                        <button className='btnAthleteID' onClick={() => window.deleteEntryMark(entry.ID, true)}>Clear<br />Series</button>
                    </td>

                  
                    <td className="athlete bold" onClick={() => athleteClick(entry.AID, "v", entry.VAD, entry.ID)}>{flag}<span>{entry.A.N}</span>{aff}</td>
                  <td className="mark center bold">{entry.M} {multiPoints}{entry.Q}{entry.DQR}<div className="english">{fractions(entry.ME)}</div>{tsPoints}</td>
                  {heights.map(function (height, i) {
                      var heightStr = height.replace(".", "-");
                      if (entry.VAD) {
                          if (entry.VAD[heightStr]) {
                              if (entry.VAD[heightStr].A) {
                                  return <td key={entry.BIB + "-" + height} className="vAttempt">{entry.VAD[heightStr].A}</td>;
                              } else {
                                  return <td key={entry.BIB + "-" + height} className="vAttempt"></td>;
                              }
                          } else {
                              return <td key={entry.BIB + "-" + height} className="vAttempt"></td>;
                          }
                      } else {
                          return <td key={entry.BIB + "-" + height} className="vAttempt"></td>;
                      }
                 })}
                 {lph}
                </tr>
           );
       };

        return <table className={tableClass}>
                    <thead>
                        <tr><th>Place</th><th></th><th>Athlete</th><th className='center'>Result</th>{heightsTH}<th className="center hand" onClick={() => this.posSort()}>Pos</th></tr>
                    </thead>
                    <tbody>{entryArray.map(createEntry)}</tbody>
                </table>;
   }
}

class HeatResultTable extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        var meta = this.props.meta;
        var entryArray = this.props.entryArray;
        var hasWind = this.props.hasWind;
        var eventType = this.props.eventType;
        var heatWord = eventType === "RUN" || eventType === "STRAIGHT" || eventType === "RELAY" ? "Heat" : "Flight";
        var heatHead = null;
            if (this.props.hsf === 0) {
                heatHead=<tr className="heatName"><th colSpan="5">Pending {heatWord} Assignment</th></tr>;
            } else {
                heatHead = <tr className="heatName"><th colSpan="5">{heatWord} {this.props.hsf} <button className="btn" onClick={() => window.setCurrentHeat(this.props.meid, this.props.hsf)}>Current</button></th></tr>;
            }
        
        var windRow = null;
        if (entryArray[0].W !== undefined && entryArray[0].W !== "" && hasWind) {
            var windRowClass = entryArray[0].W > 2 ? "resultWind aided" : "resultWind";
            windRow=<tr><th colSpan="4" className={windRowClass}>Wind: {entryArray[0].W.toFixed(1)} m/s</th></tr>;
        }

        return <table className="raceResults">
                    <thead>
                        {heatHead}
                        {windRow}
                        <tr><th>Pl</th><th></th><th>Athlete</th><th className='right'>Mark</th><th className='center'>Ln/Pos</th></tr>
                    </thead>
                    <tbody>{entryArray.map(function (e) { return <HeatResultRow key={"hr-" + e.HSF + "-" + e.BIB} entry={e} showFlag={meta.showFlag} showLogo={meta.showLogo} showAff={meta.showAff} img={meta.img} />})}</tbody>
              </table>;
    }
}

class HeatResultRow extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        var entry = this.props.entry;
        var flag = null, aff=null;
        
        if(this.props.showFlag) {
            flag = entry.A.CC ? <div className="aff"><img src={'/img/' + this.props.img + 'flags/' + entry.A.CC + '.png'} />{entry.A.CC}</div> : null;
            
        }
        if (this.props.showAff) {
            if (entry.TN) {
                if (this.props.showLogo) {
                    flag = entry.TC ? <div className="aff"><img src={'/img/' + this.props.img + 'logos/' + entry.TC + '.png'} /></div> : null;
                    
                }
                var year = entry.Y ? "[" + entry.Y + "]" : null;
                aff=entry.TN ? <div className="affiliation">{entry.TN} {year}</div>: null;
            } else {
                if (this.props.showLogo) {
                    flag = entry.A.TC ? <div className="aff"><img src={'/img/' + this.props.img + 'logos/' + entry.A.TC + '.png'} /></div> : null;
                    
                }
                aff=entry.A.A ? <div className="affiliation">{entry.A.A}</div>: null;
            }   
        }

        var place;
        if (entry.DNS) place = "DNS";
        else if (entry.DNF) place = "DNF";
        else if (entry.DQ) place = "DQ";
        else if (entry.HP) place = entry.HP;

        var dqr=null;
        if (entry.hasOwnProperty("DQR")) {
            if (entry.DQR == "FS") place = "FS";
            else dqr=<small>[{entry.DQR}]</small>
        }

        if (entry.P) {
            place += " (" + entry.P + ")";
        }

        return (
            <tr>
                <td>{place}</td>
                <td style={{ width: '1px', whiteSpace: 'nowrap' }}>
                    <button className='btnAthleteID' onClick={() => window.changeEntry(entry.ID, "DNS")}>DNS<br />Toggle</button>&nbsp;&nbsp;
                    <button className='btnAthleteID' onClick={() => window.changeEntry(entry.ID, "DNF")}>DNF<br />Toggle</button>&nbsp;&nbsp;
                    <button className='btnAthleteID' onClick={() => window.changeEntry(entry.ID, "DQ")}>DQ<br />Toggle</button>&nbsp;&nbsp;
                    <button className='btnAthleteID' onClick={() => window.deleteEntry(entry.ID)}>Delete<br />Entry</button>&nbsp;&nbsp;
                </td>
                
                <td className="athlete bold" onClick={() => athleteClick(entry.AID)}>{flag}<span>{entry.A.N}</span>{aff}</td>
                <td className="right bold">{entry.M} {entry.Q}{dqr}</td>
                <td className='center'>{entry.LP}</td>
            </tr>
        );

    }
}

class Records extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {

        if (!this.props.records) {
            return <div id="records">
                    <h3>Records</h3>
                        Records not available
                   </div>
        }

        var records = this.props.records.sort(function (a, b) {
            var aType = a.T;
            var bType = b.T;

            switch (a.T) {
                case "WR":
                    aType = 10;
                    break;
                case "AR":
                    aType = 20;
                    break;
                case "MR":
                    aType = 100;
                    break;
                case "HF":
                    aType = 110;
                    break;
                case "WL":
                    aType = 200;
                    break;
                case "AL":
                    aType = 210;
                    break;
                case "OS":
                    aType = 1000;
                    break;
                default:
                    aType = 500;
            }

            switch (b.T) {
                case "WR":
                    bType = 10;
                    break;
                case "AR":
                    bType = 20;
                    break;
                case "MR":
                    bType = 100;
                    break;
                case "HF":
                    bType = 110;
                    break;
                case "WL":
                    bType = 200;
                    break;
                case "AL":
                    bType = 210;
                    break;
                case "OS":
                    bType = 1000;
                    break;
                default:
                    bType = 500;
            }

            if (aType > bType)
                return 1;
            else if (aType < bType)
                return -1;
            else
                return 0;
        });

        var rRow = function (r) {
            r.D = r.D == 'Jan 01, 0001' ? '' : r.D.includes("Dec 31,") ? r.D.slice(-4) : r.D;
            return <tr><td className="type">{r.T}</td><td className="athlete"><span className="bold">{r.N}</span><br/><small>{r.A}</small></td><td className="bold">{r.M}</td><td>{r.D}<br /><small>{r.L}</small></td></tr>;
        };
        return <div id="records">
                            <h3>Records</h3>
                            <table id="resultRecords" cellSpacing="0">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>{records.map(rRow)}</tbody>
                            </table>
                        </div>
    }
}

class HeatTrackResults extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {

        var meta = this.props.meta;
        var athleteClick = this.props.athleteClick;

        var entries = this.props.currentEvent.ED;
        var hasHeats = this.props.currentEvent.HH;
        var eventType = this.props.currentEvent.E.C;
        var currentHeat = this.props.currentEvent.CH;
        var meid = this.props.currentEvent.ID;
        /*  not needed for heat results
        var bubble = this.props.currentEvent.BC;
        */
        var currentLap = this.props.currentEvent.CL;
        var splitList = this.props.currentEvent.SL;
        var hasReact = this.props.currentEvent.HR;
        var hasWind = this.props.currentEvent.HW;
        var status = this.props.currentEvent.S;

        var entryArray = [];
        var flip = false;
        for (var e in entries) {
            if (entries[e].HSF == currentHeat)
                entryArray.push(entries[e]);
        }

        entryArray.sort(sortPlaces);

        var tableClass = "raceResults";
        
        var windRow=null;
        var reactTH = hasReact ? <th className="center">React</th> : null;
        var heatTH = hasHeats ? <th className="center">Heat</th> : null;
        var windTH = hasHeats && hasWind ? <th className="center">Wind</th> : null;
        var splits = [];
        var splitReverse = false;
        if (splitList) {
            splits = splitList.split(",");
            if (splits.length > 4) {
                tableClass += "";
            }
            var cl = currentLap;
            entryArray.sort(function (a, b) {

                var aPlace; 
                var bPlace;
                if (a.P) 
                    aPlace = a.P;
                else if (a.SPD)
                    aPlace = a.SPD[cl] ? a.SPD[cl].P : undefined;
                else
                    if (a.sortPlace)
                        aPlace = a.sortPlace;
                        //aPlace = a.HSF * 1000 + a.LP;
                    else
                        aPlace = 999999;

                if (b.P)
                    bPlace = b.P;
                else if (b.SPD)
                    bPlace = b.SPD[cl] ? b.SPD[cl].P : undefined;
                else
                    if (b.sortPlace)
                        bPlace = b.sortPlace;
                        //bPlace = b.HSF * 1000 + b.LP;
                    else
                        bPlace = 999999;

                if (cl > 1) {
                    if ((!aPlace || aPlace === 9999) && a.SPD[cl - 1]) aPlace = a.SPD[cl - 1].P + 500; else if ((!aPlace || aPlace === 9999) && a.sortPlace) aPlace = a.sortPlace;
                    if ((!bPlace || bPlace === 9999) && b.SPD[cl - 1]) bPlace = b.SPD[cl - 1].P + 500; else if ((!bPlace || bPlace === 9999) && b.sortPlace) bPlace = b.sortPlace;
                } 

                if (!aPlace)
                    return 1;
                if (!bPlace)
                    return -1;
                if (aPlace < bPlace)
                    return -1;
                if (aPlace > bPlace)
                    return 1;
                return 0;
            });

            splits.splice(currentLap, splits.length - currentLap);
            if (status == "Live" || status == "Reviewing") {
                splits.reverse();
                splitReverse = true;
            }
        }

        if (entryArray[0].W !== undefined && entryArray[0].W !== "" && !hasHeats && hasWind) {
            var windRowClass = entryArray[0].W > 2 ? "resultWind aided" : "resultWind";
            windRow=<tr><th colSpan="4" className={windRowClass}>Wind: {entryArray[0].W.toFixed(1)} m/s</th></tr>;
        }
        
        var createEntry = function (entry, index) {
            var reactTD=null;
            var heatTD=null;
            var windTD = null;
            var tiebreak = null;

            if (hasReact) {
                if (entry.RT)
                    reactTD = <td className="center">{entry.RT.toFixed(3)}</td>;
            else
                    reactTD = <td className="center"></td>;
            }

            if (hasHeats) {
                heatTD = <td className="center">{entry.HSF}</td>;
                if (hasWind) {
                    if (entry.W !== undefined && entry.W!=="") {
                        var windTDClass = entry.W > 2 ? "center aided" : "center";
                        windTD = <td className={windTDClass}>{entry.W.toFixed(1)} m/s</td>;
                    } else {
                        windTD = <td></td>;
                    }
                }
            }

            if (entry.MTB) {
                tiebreak=<div className="small">{entry.MTB}</div>;
            }

            
                 
            var place = null, flag = null, aff = null;
            if(meta.showFlag) {
                flag = entry.A.CC ? <div className="aff"><img src={'/img/' + meta.img + 'flags/' + entry.A.CC + '.png'} />{entry.A.CC}</div> : null;
            }
            if (meta.showAff) {
                if (entry.TN) {
                    if (meta.showLogo) {
                        flag = entry.TC ? <div className="aff"><img src={'/img/' + meta.img + 'logos/' + entry.TC + '.png'} /></div> : null;
                    }
                    var year = entry.Y ? "[" + entry.Y + "]" : null;
                    aff=entry.TN ? <div className="affiliation">{entry.TN} {year}</div>: null;
                } else {
                    if (meta.showLogo) {
                        flag = entry.A.TC ? <div className="aff"><img src={'/img/' + meta.img + 'logos/' + entry.A.TC + '.png'} /></div> : null;
                    }
                    aff=entry.A.A ? <div className="affiliation">{entry.A.A}</div>: null;
                }
            }

            if (entry.RRD) {
                var year = entry.Y ? "[" + entry.Y + "]" : null;
                aff = <div className="affiliation">{year} {entry.RRD.filter(function (rr) { return rr.L > 0 && rr.L <= 4 }).map(function (rr) { return rr.A ? rr.A.N ? rr.A.N : "" : "" }).join(", ")}</div>;
            }

            if (entry.DNS || entry.P === 999) place = "DNS";
            else if (entry.DNF || entry.P === 997) place = "DNF";
            else if (entry.DQ || entry.P === 996) place = "DQ";
            else if (entry.P === 998) place = "FS";
            else if (entry.P) place = entry.P;

            var dqr=null;
            if (entry.hasOwnProperty("DQR")) {
                if (entry.DQR == "FS") place = "FS";
                else dqr=<small>[{entry.DQR}]</small>
            }

            var multiPoints = null;
            if (entry.hasOwnProperty('MP')) {
                multiPoints = <span className="multipoints">{entry.MP} <small>{entry.MPST} ({entry.MPSTP})</small></span>
            }

            return (
              <tr key={entry.BIB}>
                  <td className="bold">{place}</td>
        
        <td className="athlete bold" onClick={() => athleteClick(entry.AID)}><span>{entry.A.N}</span>{aff}</td>
        <td className="right bold">{entry.M} {multiPoints}{entry.Q} {tiebreak}{dqr}</td>
        {reactTD}
        {splits.map(function (split, i) {
            var ls = "-", mv = null;
            var iPos = splitReverse ? splits.length - i : i + 1;
            if (entry.SPD) {
                if (entry.SPD[iPos]) {
                    if (entry.SPD[iPos].P !== 9999) {
                        if (iPos > 1) {
                            ls = entry.SPD[iPos].LS;
                            if (entry.SPD[iPos].M > 0)
                                mv = <span className="up">{entry.SPD[iPos].M}</span>;
                        else if (entry.SPD[iPos].M < 0)
                            mv = <span className="down">{entry.SPD[iPos].M}</span>;
                        else if (entry.SPD[iPos].M === 0)
                            mv = <span className="same"></span>;
                        }
                        return <td key={entry.BIB + "-S" + (iPos)} className="center split" onClick={() => window.deleteSplit(entry.ID, iPos)}>
                      <div>{entry.SPD[iPos].CS}</div>
                      <div className="small">{ls}</div>
                      <div className="small">Pl: {entry.SPD[iPos].P} {mv}</div>
                  </td>;
                    } else {
                        return <td key={entry.BIB + "-S" + (iPos)} className="center split"></td>;
                    }
                } else {
                    return <td key={entry.BIB + "-S" + (iPos)} className="center split"></td>;
                }
            } else {
                return <td key={entry.BIB + "-S" + (iPos)} className="center split"></td>;
            }
        })}
        {windTD}
        {heatTD}
        <td className="center">{entry.LP}</td>
    </tr>
            );
    };

    

    return <div className="currentHeat"><h3>Current Heat</h3><table className={tableClass}>
                <thead>
    {windRow}
            <tr><th>Place</th><th>Athlete</th><th className='right'>Result</th>{reactTH}{splits.map(function (split, i) { return <th key={split + "m"} className="center"><div onClick={() => window.deleteSplitPoint(meid, i + 1)}>{split}</div><button className="btn" onClick={() => window.setCurrentSplit(meid, splitReverse ? splits.length - i : i + 1)}>Current</button></th>;})}{windTH}{heatTH}<th className="center">Ln/Pos</th></tr>
                </thead>
                <tbody>{entryArray.map(createEntry)}</tbody>
          </table>
            
          </div>

    }
}

class MultiResults extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        var meta = this.props.meta;
        var entries = this.props.entries;
        var eventType = this.props.eventType;
        var athleteClick = this.props.athleteClick;

        var entryArray = [];
        for (var e in entries) {
            entryArray.push(entries[e]);
        }

        entryArray.sort(sortPlaces);

        var tableClass = "raceResults multiTable";
        
        var header = null;
        var colCount;
        
        switch(eventType) {
            case "Decathlon":
                colCount=10;
                break;
            case "Heptathlon":
                colCount=7;
                break;
            case "Indoor Heptathlon":
                colCount=7;
                break;
            case "HSG Pentathlon":
            case "HSB Pentathlon":
            case "Outdoor Pentathlon":
            case "Indoor Pentathlon":
                colCount=5;
                break;
        }
        if (eventType == "Decathlon") {
            header=<tr><th>Place</th><th>Athlete</th><th className='center'>Total</th><th className="center">100m</th><th className="center">LJ</th><th className="center">SP</th><th className="center">HJ</th><th className="center">400m</th><th className="center">110mH</th><th className="center">DT</th><th className="center">PV</th><th className="center">JT</th><th className="center">1500m</th></tr>;
        }

        if (eventType == "Heptathlon") {
            header=<tr><th>Place</th><th>Athlete</th><th className='center'>Total</th><th className="center">100mH</th><th className="center">HJ</th><th className="center">SP</th><th className="center">200m</th><th className="center">LJ</th><th className="center">JT</th><th className="center">800m</th></tr>;
        }

        if (eventType == "Indoor Heptathlon") {
            header=<tr><th>Place</th><th>Athlete</th><th className='center'>Total</th><th className="center">60m</th><th className="center">LJ</th><th className="center">SP</th><th className="center">HJ</th><th className="center">60mH</th><th className="center">PV</th><th className="center">1000m</th></tr>;
        }

        if (eventType == "Indoor Pentathlon") {
            header=<tr><th>Place</th><th>Athlete</th><th className='center'>Total</th><th className="center">60mH</th><th className="center">HJ</th><th className="center">SP</th><th className="center">LJ</th><th className="center">800m</th></tr>;
        }

        if (eventType == "Outdoor Pentathlon" || eventType == "HSG Pentathlon" || eventType == "HSB Pentathlon") {
            header = <div className="tr"><div className="th">Place</div><div className="th">Athlete</div><div className='th center'>Total</div><div className="th center">100H/110H</div><div className="th center">HJ</div><div className="th center">SP</div><div className="th center">LJ</div><div className="th center">800m/1500m</div></div>;
        }
        
        
        var createEntry = function (entry, index) {
        
        
            var place = null, flag = null, aff = null;

            var tsPoints = null;
            if (entry.hasOwnProperty("PT")) {
                tsPoints =  entry.PT == 1 ? <div className="small tsPoints">{entry.PT} Pt</div> : <div className="small tsPoints">{entry.PT} Pts</div>;
            }

            if(meta.showFlag) {
                flag = entry.A.CC ? <div className="aff"><img src={'/img/' + meta.img + 'flags/' + entry.A.CC + '.png'} />{entry.A.CC}</div> : null;
            }
            if (meta.showAff) {
                if (entry.TN) {
                    if (meta.showLogo) {
                        flag = entry.TC ? <div className="aff"><img src={'/img/' + meta.img + 'logos/' + entry.TC + '.png'} /></div> : null;
                    }
                    var year = entry.Y ? "[" + entry.Y + "]" : null;
                    aff=entry.TN ? <div className="affiliation">{entry.TN} {year}</div>: null;
                } else {
                    if (meta.showLogo) {
                        flag = entry.A.TC ? <div className="aff"><img src={'/img/' + meta.img + 'logos/' + entry.A.TC + '.png'} /></div> : null;
                    }
                    aff=entry.A.A ? <div className="affiliation">{entry.A.A}</div>: null;
                }
            }
            if (entry.DNS || entry.P === 999) {
                place = "DNS";
            }
            else if (entry.DNF || entry.P === 997) {
                place = "DNF";
                entry.MM = null;
            }
            else if (entry.DQ || entry.P === 996) {
                place = "DQ";
                entry.MM = null;
            }
            else if (entry.P === 998) {
                place = "FS";
            }
            else if (entry.P) place = entry.P;

            var pointsCols = [];
            if (entry.M) {
                var pointArray = entry.M.split(",");
                var len = pointArray.length;
                for (var x = 0; x < colCount; x++) {
                    if (x >= len)
                        pointsCols.push(<td></td>);
                    else if (pointArray[x] == "")
                        pointsCols.push(<td></td>);
                    else {
                        var pointDetail = pointArray[x].split("|");
                        pointsCols.push(<td className="center points"><div>{pointDetail[0]}</div>{pointDetail[1]} ({pointDetail[4]})<br/><small>{pointDetail[2]} ({pointDetail[3]})</small></td>);
                    }
                }
            } else {
                for (var x = 0; x < colCount; x++) {
                    pointsCols.push(<td></td>);
                }
            }


            return (
              <tr key={entry.BIB}>
                  <td className="bold">{place}</td>
                    
                  <td className="athlete bold" onClick={() => athleteClick(entry.AID)}>{flag}<span>{entry.A.N}</span>{aff}</td>
                    <td className="center bold">{entry.MM}{entry.DQR}{tsPoints}</td>
                    {pointsCols}
                </tr>
                        );
                };


    return <div className="resultsDiv">
            <table className={tableClass}>
                <thead>
                   {header}
                </thead>
                <tbody>{entryArray.map(createEntry)}</tbody>
          </table>
          </div>

    }
}

class EventGraphics extends React.Component {
    constructor(props) {
        super(props);
        this.getWeather = this.getWeather.bind(this);
        this.updateWeather = this.updateWeather.bind(this);
        this.showInterview = this.showInterview.bind(this);
        this.showGraphic = this.showGraphic.bind(this);
    }
    showEventTitle(mid) {
        var data = "";

        data = '{"gu":' + window.globalGU + ',"mid":' + mid + '}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncVideoboard/ShowEventTitle/' + mid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    getWeather() {
        var weatherAPIUrl = "https://api.forecast.io/forecast/";
        var weatherAPIKey = "07ab5b2f55be755c9cde4d8e6ac64dcc";
        var coordinates = "40.7828647,-73.9675438";

        var weatherAPI = weatherAPIUrl + weatherAPIKey + "/" + coordinates + "?callback=?";
        var classThis = this;
        $.getJSON(weatherAPI, function (data) {
            var t = Number(data.currently.temperature);
            var w = Number(data.currently.windSpeed);
            var h = Number(data.currently.humidity);
            //var temp = Math.round(t) + "&deg;F / " + Math.round((t - 32) * .5556) + "&deg;C";
            var temp = Math.round(t) + "&deg;F";
            //var wind = Math.round((w * 0.44704), 1).toFixed(1) + " m/s";
            var wind = w.toFixed(0) + " mph";
            var humidity = Math.round(h * 100) + "%";
            var time = moment.unix(data.currently.time).tz(data.timezone).format('HH:mm z');
            classThis.temp.value=temp;
            classThis.wind.value =wind;
            classThis.humidity.value =humidity;
            classThis.conditions.value =data.currently.summary;
            classThis.time.value =time;
        });
    }
    updateWeather(mid) {
        var data = '{"gu":' + window.globalGU + ',"layer":"weather","temp":"' + this.temp.value + '","humidity":"' + this.humidity.value + '","wind":"' + this.wind.value + '","conditions":"' + this.conditions.value + '","time":"' + this.time.value + '"}';
        
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncVideoboard/ShowWeather/' + mid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showInterview() {
        var gu = window.globalGU;

        var data = '{"gu":' + window.globalGU + ',"layer":"athlete","name":"' + this.iName.value + '", "affiliation":"' +this.iAff.value + '","note":"' + this.iNote.value + '", "logo":"' + this.iAff.value + '","logoFolder":"flags"}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncVideoboard/ShowInterview/' + gu, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showGraphic() {
        var gu = window.globalGU;

        var data = '{"gu":' + window.globalGU + ',"layer":"graphic","src":"' + this.graphicSRC.value + '"}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncVideoboard/ShowGraphic/' + gu, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showCommentators(mid) {
        var data = "";

        data = '{"gu":' + window.globalGU + ',"mid":' + mid + '}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncVideoboard/ShowCommentators/' + mid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }

    render() {
        var mid = this.props.mid;
        var subHeadStyle = { width: '300px' };
        return <div style={{margin:'15px'}}>
            <div id="title">
                <button onClick={() => this.showEventTitle(mid)} className="btn btn-secondary">Show Title</button>
            </div>
            <br/>
            <div id="commentators">
                <button onClick={() => this.showCommentators(mid)} className="btn btn-secondary">Show Commentators</button>
            </div>
            <br />
            <div id="weather">
                <button onClick={() => this.updateWeather(mid)} className="btn btn-secondary">Show Weather</button>
                <button onClick={() => this.getWeather()} className="btn btn-secondary">Get Latest Weather</button>
                <input type="text" ref={input => this.temp = input} placeholder="Temp" />
                <input type="text" ref={input => this.humidity = input} placeholder="Humdity" />
                <input type="text" ref={input => this.wind = input} id="wind" placeholder="Wind" />
                <input type="text" ref={input => this.conditions = input} placeholder="Conditions" />
                <input type="text" ref={input => this.time = input} placeholder="Time" />
            </div>
            <br />
            <div id="interview">
                <button onClick={() => this.showInterview()} className="btn btn-secondary">Show Interview</button>
                <input type="text" ref={input => this.iName = input} placeholder="Name"  />
                <input type="text" ref={input => this.iNote = input} placeholder="Title/Note"  />
                <input type="text" ref={input => this.iAff = input} placeholder="AFF"  />

            </div>
            <br />
            <div id="customGraphic">
                <button onClick={() => this.showGraphic()} className="btn btn-secondary">Show Custom Graphic</button>
                <input type="text" ref={input => this.graphicSRC = input}  placeholder="filename"  />
            </div>

        </div>

    }
}

RightBar.propTypes = {
    athleteInfo: PropTypes.object
};

ScheduleDay.propTypes = {
    eventClick: PropTypes.func
};

ScheduleEvent.propTypes = {
    eventClick: PropTypes.func
};

SelectedEvent.propTypes = {
    currentEvent: PropTypes.object,
    athleteClick: PropTypes.func
};

StartList.propTypes = {
    entries: PropTypes.object,
    athleteClick: PropTypes.func
};

TrackResults.propTypes = {
    entries: PropTypes.object,
    athleteClick: PropTypes.func
};

HFieldResults.propTypes = {
    entries: PropTypes.object,
    athleteClick: PropTypes.func
};

VFieldResults.propTypes = {
    entries: PropTypes.object,
    athleteClick: PropTypes.func
};

EventGraphics.propTypes = {
    entries: PropTypes.object,
    athleteClick: PropTypes.func
};

function sortPlaces(a, b) {
    var aPlace, bPlace;

    if (a.P) {
        aPlace = a.P
    } else if (a.DNS) {
        aPlace = 999999;
    } else if (a.DQ) {
        aPlace = 999995;
    } else if (a.DNF) {
        aPlace = 999990;
    } else {
        if (a.HSF && a.LP)
            aPlace = a.HSF * 1000 + parseInt(a.LP,10);
        else
            aPlace = 999999;
    }

    if (b.P) {
        bPlace = b.P
    } else if (b.DNS) {
        bPlace = 999999;
    } else if (b.DQ) {
        bPlace = 999995;
    } else if (b.DNF) {
        bPlace = 999990;
    } else {
        if (b.HSF && b.LP)
            bPlace = b.HSF * 1000 + parseInt(b.LP,10);
        else
            bPlace = 999999;
    }


    if (!aPlace)
        return 1;
    if (!bPlace)
        return -1;
    if (aPlace < bPlace) {
        a.sortPlace = aPlace;
        b.sortPlace = bPlace;
        return -1;
    }
    if (aPlace > bPlace) {
        a.sortPlace = aPlace;
        b.sortPlace = bPlace;
        return 1;
    }
    a.sortPlace = aPlace;
    b.sortPlace = bPlace;
    return 0;
}

function sortPos(a, b) {
    var aPlace, bPlace;

    if (a.PF) {
        aPlace = a.PF
    } else if (a.DNS) {
        aPlace = 999999;
    } else if (a.DQ) {
        aPlace = 999995;
    } else if (a.DNF) {
        aPlace = 999990;
    } else {
        if (a.HSF && a.LP)
            aPlace = a.HSF * 1000 + parseInt(a.LP, 10);
        else
            aPlace = 999999;
    }

    if (b.PF) {
        bPlace = b.PF
    } else if (b.DNS) {
        bPlace = 999999;
    } else if (b.DQ) {
        bPlace = 999995;
    } else if (b.DNF) {
        bPlace = 999990;
    } else {
        if (b.HSF && b.LP)
            bPlace = b.HSF * 1000 + parseInt(b.LP, 10);
        else
            bPlace = 999999;
    }


    if (!aPlace)
        return 1;
    if (!bPlace)
        return -1;
    if (aPlace < bPlace) {
        a.sortPlace = aPlace;
        b.sortPlace = bPlace;
        return -1;
    }
    if (aPlace > bPlace) {
        a.sortPlace = aPlace;
        b.sortPlace = bPlace;
        return 1;
    }
    a.sortPlace = aPlace;
    b.sortPlace = bPlace;
    return 0;
}


ReactDOM.render(<FranklinApp en={undefined} meetID={mid || undefined} />, document.getElementById('franklinApp'));